export enum Dialog {
  Confirm, // Contrasted against PROMPT, used for more complex scenarios.
  AddProjectFile,
  AddNewProject,
  Error,
  Prompt, // Simple prompt - intended when key question is entirely within the title.
}
